import type { TFunction } from 'i18next'
import type { VideoAssetItem } from '../api'

export function videoAssetOriginLabel(item: VideoAssetItem, t: TFunction<'video'>): string {
  if (item.origin_kind === 'user_upload' || item.upload_asset_id) {
    return t('assets.sources.upload')
  }
  if (item.origin_display_name) {
    if (!item.origin_project_exists && item.origin_kind === 'canvas') {
      return `${item.origin_display_name}${t('assets.origin.projectDeletedSuffix')}`
    }
    return item.origin_display_name
  }
  if (item.origin_is_legacy) {
    return t('assets.origin.legacyUnknown')
  }
  return t('assets.sources.vistoera_generated')
}

export function videoAssetOriginSecondary(item: VideoAssetItem): string | null {
  return item.origin_secondary_label || null
}

export function videoAssetOriginNavigable(item: VideoAssetItem): boolean {
  return Boolean(item.origin_navigate_enabled && item.origin_navigate_route)
}
